import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import GoogleButton from './GoogleButton';
import { EyeIcon } from '../Common/Icons';

const RegisterForm = ({ onSubmit, formData, handleChange, error, success }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <form
      onSubmit={onSubmit}
      noValidate
      className="flex flex-col gap-8 items-start p-8 w-full bg-white rounded-2xl shadow-xl border border-gray-100 max-w-md"
    >
      <div className="flex flex-col gap-3 justify-center items-start w-full">
        <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-2">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
          </svg>
        </div>
        <h1 className="w-full text-2xl md:text-3xl font-bold text-left text-gray-900 text-center">
          Buat Akun Baru
        </h1>
        <p className="w-full text-sm md:text-base text-left text-gray-600 text-center">
          Isi detail di bawah untuk mendaftar ke TERAPLUS.
        </p>
      </div>

      {error && (
        <div className="w-full p-3 bg-red-50 border border-red-200 rounded-xl">
          <p className="text-red-700 text-sm text-center">{error}</p>
        </div>
      )}
      {success && (
        <div className="w-full p-3 bg-green-50 border border-green-200 rounded-xl">
          <p className="text-green-700 text-sm text-center">{success}</p>
        </div>
      )}

      {/* Google Button - More prominent */}
      <GoogleButton className="w-full py-3 text-sm md:text-base" />

      {/* OR Divider */}
      <div className="flex gap-4 justify-center items-center w-full">
        <div className="h-px bg-gray-200 flex-grow" />
        <span className="text-xs md:text-sm text-center text-gray-500 font-medium">
          Atau Daftar dengan Email
        </span>
        <div className="h-px bg-gray-200 flex-grow" />
      </div>

      <div className="flex flex-col gap-5 items-start w-full">
        <div className="flex flex-col gap-2 items-start w-full">
          <label
            htmlFor="namaLengkap"
            className="w-full text-sm font-semibold text-gray-700"
          >
            Nama Lengkap
          </label>
          <input
            id="namaLengkap"
            name="namaLengkap"
            type="text"
            required
            value={formData.namaLengkap}
            onChange={handleChange}
            placeholder="Masukkan nama lengkap Anda"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-gray-900 transition-all duration-200"
          />
        </div>
        <div className="flex flex-col gap-2 items-start w-full">
          <label
            htmlFor="email"
            className="w-full text-sm font-semibold text-gray-700"
          >
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={formData.email}
            onChange={handleChange}
            placeholder="alamat.email@contoh.com"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-gray-900 transition-all duration-200"
          />
        </div>
        {/* Added Affiliasi Field */}
        <div className="flex flex-col gap-2 items-start w-full">
          <label
            htmlFor="affiliasi"
            className="w-full text-sm font-semibold text-gray-700"
          >
            Affiliasi (Nama Instansi/Perusahaan/Pribadi)
          </label>
          <input
            id="affiliasi"
            name="affiliasi"
            type="text"
            required
            value={formData.affiliasi}
            onChange={handleChange}
            placeholder="Masukkan affiliasi Anda"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-gray-900 transition-all duration-200"
          />
        </div>
        {/* Added No HP Field */}
        <div className="flex flex-col gap-2 items-start w-full">
          <label
            htmlFor="noHp"
            className="w-full text-sm font-semibold text-gray-700"
          >
            No. HP (WhatsApp Aktif)
          </label>
          <input
            id="noHp"
            name="noHp"
            type="tel"
            required
            value={formData.noHp}
            onChange={handleChange}
            placeholder="Contoh: 081234567890"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-gray-900 transition-all duration-200"
          />
        </div>
        <div className="flex flex-col gap-2 items-start w-full">
          <label
            htmlFor="password"
            className="w-full text-sm font-semibold text-gray-700"
          >
            Password
          </label>
          <div className="w-full flex rounded-xl shadow-sm border border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/20 transition-all duration-200">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              required
              value={formData.password}
              onChange={handleChange}
              placeholder="Minimal 8 karakter"
              className="flex-1 block w-full rounded-l-xl border-0 px-4 py-3 placeholder-gray-400 focus:ring-0 text-gray-900"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="inline-flex items-center px-4 rounded-r-xl border-l border-gray-300 bg-gray-50 text-gray-500 hover:bg-gray-100 transition-colors duration-200"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <EyeIcon className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start w-full">
          <label
            htmlFor="confirmPassword"
            className="w-full text-sm font-semibold text-gray-700"
          >
            Konfirmasi Password
          </label>
          <div className="w-full flex rounded-xl shadow-sm border border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/20 transition-all duration-200">
            <input
              id="confirmPassword"
              name="confirmPassword"
              type={showConfirmPassword ? 'text' : 'password'}
              required
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Ulangi password Anda"
              className="flex-1 block w-full rounded-l-xl border-0 px-4 py-3 placeholder-gray-400 focus:ring-0 text-gray-900"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="inline-flex items-center px-4 rounded-r-xl border-l border-gray-300 bg-gray-50 text-gray-500 hover:bg-gray-100 transition-colors duration-200"
              aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
            >
              <EyeIcon className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="w-full text-right text-sm">
          <a href="https://teraplus.unesa.ac.id/request-password-reset" className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
            Lupa Password?
          </a>
        </div>

        <button
          type="submit"
          className="w-full flex justify-center py-3 px-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-semibold rounded-xl shadow-lg hover:from-green-700 hover:to-emerald-700 focus:outline-none focus:ring-2 focus:ring-green-500/20 transition-all duration-200 transform hover:-translate-y-0.5"
        >
          Daftar
        </button>
      </div>

      <div className="flex gap-1 justify-center items-center w-full">
        <p className="text-sm text-center text-gray-600">
          Sudah punya akun?{' '}
          <Link to="/login" className="font-semibold text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
            Masuk
          </Link>
        </p>
      </div>
    </form>
  );
};

export default RegisterForm;
